export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9619.eb1404b6.jpg";